import { useEffect, useState } from 'react';
import '../styles/dashboard.css';
import calender from '../assets/images/small/date.svg';
import pilgrim from '../assets/images/small/pilgrim.svg';
import city from '../assets/images/small/City.svg';
import state from '../assets/images/small/State.svg';
import api from '../services/api';
import CustomSelect from './CustomSelect';
import { useNavigate } from "react-router-dom";

const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

const getToday = () => formatDate(new Date());

const getOneMonthBack = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return formatDate(date);
};


const LeadDashboard = () => {

  // --------------------
  // FILTER STATES
  // --------------------
  const [startDate, setStartDate] = useState(getOneMonthBack());
  const [endDate, setEndDate] = useState(getToday());
  const [categoryId, setCategoryId] = useState('');
  const [stateName, setStateName] = useState('');
  const [cityName, setCityName] = useState('');

  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);

  

  const navigate = useNavigate();


  // --------------------
  // API CALL
  // --------------------



  
const handleCardClick = (type, module) => {
  navigate("/tour-opretor", {
    state: { filterType: type, moduleType: module }
  });
};

const handleCardPackageClick = (type, module) => {
  if(module === "umrah"){
      navigate("/umrah-packages-list", {
      state: { filterType: type, moduleType: module }
    });
  }
};

const handleCardhajjPackageClick = (type, module) => {
  if(module === "hajj"){
      navigate("/hajj-packages-list", {
      state: { filterType: type, moduleType: module }
    });
  }
};



  const fetchVendorLeads = async () => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('start_date', startDate);
      formData.append('end_date', endDate);
      formData.append('category_id', categoryId);
      formData.append('statename', stateName);
      formData.append('cityname', cityName);

      const response = await api.post('/api/Dashboard/vendor_lead_report', formData)
      const result =  response.data;
      console.log(result)

      if (result.status === 'success') {
        setVendors(result.data);
      } else {
        setVendors([]);
      }
    } catch (error) {
      console.error('API Error:', error);
      setVendors([]);
    } finally {
      setLoading(false);
    }
  };


  const fetchCities = async (selectedState) => {
  if (!selectedState) {
    setCities([]);
    return;
  }

  setCityLoading(true);

  try {
    const formData = new FormData();
    formData.append('statename', selectedState);

    const response = await api.post(
      '/api/Dashboard/user_city_list',
      formData
    );

    const result = response.data;

    if (result.status === 'success') {
      setCities(result.data);
    } else {
      setCities([]);
    }
  } catch (error) {
    console.error('City API Error:', error);
    setCities([]);
  } finally {
    setCityLoading(false);
  }
};





  // --------------------
  // INITIAL LOAD
  // --------------------
  useEffect(() => {
    fetchVendorLeads();
  }, []);

  useEffect(() => {
    setCityName('');     // reset selected city
    fetchCities(stateName);
  }, [stateName]);


  // --------------------
  // SUBMIT HANDLER
  // --------------------
  const handleApplyFilters = (e) => {
    e.preventDefault();
    fetchVendorLeads();
  };


  


  useEffect(() => {
    if (startDate > endDate) {
      setStartDate(endDate);
    }
  }, [endDate]);


  const pilgrimageOptions = [
    { id: "2", name: "Umrah" },
    { id: "1", name: "Hajj" },
  ];


  return (
    <div className="dashboard-content">

      {/* FILTERS */}
      <div className="filter-containers">

      <div >
        <h2 style={{fontSize: '26px', fontWeight: '700', marginBottom: '15px'}}>Lead Dashbord</h2>
      </div>
        
        <form onSubmit={handleApplyFilters}>


          {/* Start Date */}
          <div className="filter-form-container">

            <div className="label-container">
              <div className="image-container">
                <img src={calender} alt="calendar" />
              </div>
              <p>Start Date</p>
            </div>
            <input
              type="date"
              value={startDate}
              max={endDate}   
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          {/* End Date */}
          <div className="filter-form-container">
            <div className="label-container">
              <div className="image-container">
                <img src={calender} alt="calendar" />
              </div>
              <p>End Date</p>
            </div>
            <input
              type="date"
              value={endDate}
              max={getToday()}   
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>


          {/* State (API later) */}
          <div className="filter-form-container">
            <div className="label-container">
              <div className="image-container">
                <img src={state} alt="state" />
              </div>
              <p>State</p>
            </div>
            <CustomSelect
              options={states}
              value={stateName}
              onChange={(val) => setStateName(val)}
              labelKey="statename"
              valueKey="statename"
              placeholder="All States"
            />


          </div>

          {/* City (API later) */}
          <div className="filter-form-container">
            <div className="label-container">
              <div className="image-container">
                <img src={city} alt="state" />
              </div>
              <p>City</p>
            </div>
            <CustomSelect
              options={cities}
              value={cityName}
              onChange={(val) => setCityName(val)}
              labelKey="cityname"
              valueKey="cityname"
              placeholder={
                cityLoading
                  ? "Loading cities..."
                  : stateName
                  ? "All Cities"
                  : "Select State First"
              }
              disabled={!stateName || cityLoading}
            />


          </div>

          {/* Apply */}
          <div className="filter-form-container">
            <button className="apply-filters" type="submit">
              Apply Filter
            </button>
          </div>

        </form>
      </div>

      {/* VENDOR LIST */}
      <div className="vendor-lead-list">
        <h2 style={{fontSize:"26px", fontWeight:700}}>Service Provider Leads</h2>

        <div className="vendor-list-table">
          <div className="table">
            <div className="table-head">
              <p className="logo">Service Provider Logo</p>
              <p className="ven-name">Service Provider Name</p>
              <p className="no-of-leads">Location</p>
              <p className="no-of-leads">Hajj Leads</p>
              <p className="no-of-leads">Umrah Leads</p>
              <p className="no-of-leads">Total Leads</p>
            </div>

            <div className="table-body">
              {loading && <p>Loading...</p>}

              {!loading && vendors.length === 0 && (
                <div className="rowtable">
                  <p>No data found</p>
                </div>
              )}

              {!loading && vendors.map((vendor) => (
                <div className="rowtable" key={vendor.vendor_id}>
                  <div className="logo-cont">
                    <img
                      src={`https://tservices.bashaarat.com${vendor.vendor_logo}`}
                      alt={vendor.vendor_name}
                    />
                  </div>
                  <p className="ven-name">{vendor.vendor_name}</p>
                  <p className="no-of-leads">{vendor.cityname}</p>
                  <p className="no-of-leads">{vendor.category_1_total}</p>
                  <p className="no-of-leads">{vendor.category_2_total}</p>
                  <p className="no-of-leads">{vendor.total_leads}</p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

    </div>
  );
};

export default LeadDashboard;
